module.exports = __webpack_public_path__ + "static/media/luggages4.a72bda70.jpg";